import React, { useEffect } from 'react';

const QuickMenu: React.FC = () => {
  useEffect(() => {
    // 1. 타입 단언을 통한 요소 선택
    const html = document.documentElement;
    const quickArea = document.querySelector('.quick-area') as HTMLElement | null;
    const quickOpen = document.querySelector('.quick-open') as HTMLButtonElement | null;
    const quickPanels = document.querySelectorAll<HTMLButtonElement>('.quick-panel');
    const quickBg = document.querySelector('.quick-bg') as HTMLElement | null;

    if (!quickArea || !quickOpen) return;

    /* ==================================================
        S:: QUICK DEPTH2 CLOSE (COMMON)
    ================================================== */
    const closeAllDepth2 = (): void => {
      quickPanels.forEach((panel) => {
        const li = panel.closest('li');
        const depth2 = li?.querySelector('.quick-depth2-w') as HTMLElement | null;

        if (!li || !depth2) return;

        li.classList.remove('active');
        depth2.style.height = '0';
        panel.setAttribute('title', '메뉴 열기');
      });
    };

    /* ==================================================
        S:: QUICK MENU OPEN / CLOSE
    ================================================== */
    const handleQuickToggle = (): void => {
      const isActive = quickArea.classList.contains('active');

      quickArea.classList.toggle('active', !isActive);
      quickOpen.setAttribute(
        'title',
        isActive ? '퀵메뉴 열기' : '퀵메뉴 닫기'
      );

      if (window.innerWidth <= 1536) {
        html.classList.toggle('overflow-hidden', !isActive);
        html.classList.toggle('quick-active', !isActive);
      }

      if (isActive) {
        closeAllDepth2();
      }
    };

    quickOpen.addEventListener('click', handleQuickToggle);

    /* ==================================================
        S:: QUICK BACKGROUND CLICK (MOBILE ONLY)
    ================================================== */
    const handleQuickBgClick = (): void => {
      if (window.innerWidth > 1536) return;
      if (!quickArea.classList.contains('active')) return;

      quickArea.classList.remove('active');
      quickOpen.setAttribute('title', '퀵메뉴 열기');
      html.classList.remove('overflow-hidden', 'quick-active');

      closeAllDepth2();
    };

    quickBg?.addEventListener('click', handleQuickBgClick);

    /* ==================================================
        S:: QUICK DEPTH2 TOGGLE
    ================================================== */
    quickPanels.forEach((panel) => {
      panel.addEventListener('click', () => {
        const li = panel.closest('li');
        const depth2 = li?.querySelector('.quick-depth2-w') as HTMLElement | null;

        if (!li || !depth2) return;

        const isActive = li.classList.contains('active');

        if (isActive) {
          depth2.style.height = '0';
          li.classList.remove('active');
          panel.setAttribute('title', '메뉴 열기');
        } else {
          depth2.style.height = `${depth2.scrollHeight}px`;
          
          // transition이 끝난 후 height를 auto로 변경하여 유연성 확보
          depth2.addEventListener(
            'transitionend',
            () => (depth2.style.height = 'auto'),
            { once: true }
          );

          li.classList.add('active');
          panel.setAttribute('title', '메뉴 닫기');
        }
      });
    });

    /* ==================================================
        S:: RESIZE HANDLER
    ================================================== */
    const handleResize = (): void => {
      if (window.innerWidth > 1536) {
        html.classList.remove('overflow-hidden', 'quick-active');
        closeAllDepth2();
      }
    };

    window.addEventListener('resize', handleResize);

    /* ==================================================
        S:: QUICK OUTSIDE CLICK (PC ONLY)
    ================================================== */
    const handleOutsideClick = (e: MouseEvent): void => {
      if (window.innerWidth <= 1536) return;
      if (!quickArea.classList.contains('active')) return;

      // 클릭된 대상이 quickArea 내부에 포함되지 않았을 때 닫기
      if (e.target instanceof Node && !quickArea.contains(e.target)) {
        quickArea.classList.remove('active');
        quickOpen.setAttribute('title', '퀵메뉴 열기');
        html.classList.remove('overflow-hidden', 'quick-active');
        closeAllDepth2();
      }
    };

    document.addEventListener('click', handleOutsideClick);

    // cleanup
    return () => {
      quickOpen.removeEventListener('click', handleQuickToggle);
      quickBg?.removeEventListener('click', handleQuickBgClick);
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <>
      <div className="quick-bg"></div>
      <aside className="quick-area">
        <div className="quick-w">
          <button type="button" title="퀵메뉴 열기" className="quick-open">
            <i className="icon icon-quick"></i>
          </button>
          {/* 20260129 수정 */}
          <ul className="quick">
            <li>
              <a href='https://www.aica-gj.kr/main.php' className="quick-btn" target="_blank" title="새 창 열림">
                AICA 홈페이지
              </a>
            </li>
            <li>
              <button type="button" title="메뉴 열기" className="quick-btn quick-panel">
                AI 통합지원 서비스 플랫폼
              </button>
                <ul className="quick-depth2-w">
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/`} className="quick-depth2" target="_blank" title="새 창 열림">AI 기업지원</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/tsp`} className="quick-depth2" target="_blank" title="새 창 열림">AI 실증지원</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/dxp`} className="quick-depth2" target="_blank" title="새 창 열림">AI 데이터지원</a></li>
                  {/* <li><a href='javascript:void(0);' className="quick-depth2" target="_blank" title="새 창 열림">AI 컴퓨팅지원</a></li> */}
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/npu`} className="quick-depth2" target="_blank" title="새 창 열림">AI 반도체지원</a></li>
                  <li><a href={`${process.env.REACT_APP_DOMAIN}/lms`} className="quick-depth2" target="_blank" title="새 창 열림">AI 융합아카데미</a></li>
                  {/* <li><a href={`${process.env.REACT_APP_DOMAIN}/biz`} className="quick-depth2" target="_blank" title="새 창 열림">사업관리시스템</a></li> */}
                </ul>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
};

export default QuickMenu;